import React from "react";

const Badge = ({ text, typeClass, colorClass }) => {
  return (
    <div className={`badge ${typeClass} ${colorClass}`}>
      <span className="chr-badge-text">{text}</span>
    </div>
  );
};

const WarningBadge = (props) => {
  return <Badge typeClass="badge-warning" {...props} />;
};

const DangerBadge = (props) => {
  return <Badge typeClass="badge-danger" {...props} />;
};

export default Badge;

export  { WarningBadge, DangerBadge };
